import { render, staticRenderFns } from "./wxLive.vue?vue&type=template&id=0c4a3d2b&scoped=true&"
import script from "./wxLive.vue?vue&type=script&lang=js&"
export * from "./wxLive.vue?vue&type=script&lang=js&"
import style0 from "./wxLive.vue?vue&type=style&index=0&id=0c4a3d2b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4a3d2b",
  null
  
)

export default component.exports